export enum UserGroup {
  AppSmsfViewKPI = 'App-SMSF-ViewKPI',
  AppSmsfEditKPI = 'App-SMSF-EditKPI',
  AppSmsfLive = 'App-SMSF-Live',
  AppSmsfDevAll = 'App-SMSF-DevAll',
  AppSmsfAllPlants = 'App-SMSF-AllPlants',
  AppSmsfProdEasyToolLife = 'App-SMSF-Prod-EasyToolLife',
  AppSmsfMachineOperator = 'App-SMSF-MachineOperator',
}
